import {Injectable} from '@angular/core';

declare var window: any;

// note: can not import log service, log service requires config service


@Injectable()
export class ConfigService {
	constructor (
	) {

		if (window.location.href.indexOf('test.oceanbluffproductions.com.s3-website-us-west-2.amazonaws.com') >= 0) {
			this.basePath = 'http://api.test.oceanbluffproductions.com:3000';		// TODO!!! - update this back to SSL after nginx termination
			this.uiBasePath = 'http://test.oceanbluffproductions.com.s3-website-us-west-2.amazonaws.com';
			this.environment = 'production';
		} else if (window.location.href.indexOf('test.oceanbluffproductions.com') >= 0) {
			this.basePath = 'https://api.test.oceanbluffproductions.com';
			this.uiBasePath = 'https://test.oceanbluffproductions.com';
			this.environment = 'production';

		} else if (window.location.href.indexOf('oceanbluffproductions.com.s3-website-us-west-2.amazonaws.com') >= 0) {
			this.basePath = 'https://api.ptffportal.org';
			this.uiBasePath = 'http://oceanbluffproductions.com.s3-website-us-west-2.amazonaws.com';
			this.environment = 'production';
		} else if (window.location.href.indexOf('oceanbluffproductions.com') >= 0) {
			this.basePath = 'https://api.ptffportal.org';
			this.uiBasePath = 'https://oceanbluffproductions.com';
			this.environment = 'production';



		} else if (window.location.href.indexOf('http://localhost:4200') >= 0) {
			this.uiBasePath = 'http://localhost:4200';
			// only used when running again local nginx
			// this.basePath = 'https://localhost';

		} else if (window.location.href.indexOf('http://localhost:8080') >= 0) {
			this.uiBasePath = 'http://localhost:8080';
		}

		// let isProd = ((window.location.href.indexOf('patmcfaul.net') >= 0) || (window.location.href.indexOf('oceanbluffproductions.com') >= 0));
		// if (isProd) {
		// 	this.basePath = 'https://api.ptffportal.org';
		// 	this.uiBasePath = 'https://oceanbluffproductions.com';
		// 	this.environment = 'production';
		// }
		this.originalHref = window.location.href;

		console.log(`'API basePath = ${this.basePath}`);
		console.log(`'UI basePath = ${this.uiBasePath}`);
		console.log(`'environment = ${this.environment}`);
		console.log(`'originalHref = ${this.originalHref}`);
	}

	basePath = 'http://localhost:3000';
	// basePath = 'https://localhost';		// used when running with nginx ssl termination
	uiBasePath = 'http://localhost:8080';
	environment = 'local';

	public originalHref = '';
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/config.service.ts